import { useMarket } from "@/context/MarketContext";
import { fmt } from "@/lib/format";

const IDX = ["NIFTY", "BANKNIFTY", "FINNIFTY", "SENSEX"];

export default function GlobalTicker() {
  const { quotes, global, connected, feed } = useMarket();
  const liveStocks = feed?.stocks === "live";
  const items = [
    ...IDX.filter((s) => quotes[s]).map((s) => ({ s, ltp: quotes[s].ltp, chg: quotes[s].chg_pct })),
    ...(global?.factors || []).map((f) => ({ s: f.name, ltp: f.ltp, chg: f.chg_pct, d: f.symbol === "USDINR" ? 4 : 2 })),
  ];
  const row = (k) => items.map((i) => (
    <span key={k + i.s} className="inline-flex items-center gap-2 px-5 font-data text-xs whitespace-nowrap">
      <span className="text-gray-500">{i.s}</span>
      <span className="text-white">{fmt(i.ltp, i.d || 2)}</span>
      <span className={i.chg >= 0 ? "text-[#00FF66]" : "text-[#FF3366]"}>{i.chg >= 0 ? "▲" : "▼"} {fmt(Math.abs(i.chg))}%</span>
    </span>
  ));
  return (
    <div className="flex items-center border-b border-white/5 bg-[#050505] h-9 overflow-hidden" data-testid="global-ticker">
      <div className="flex items-center gap-2 px-3 shrink-0 border-r border-white/5 h-full">
        <span className={`h-2 w-2 rounded-full ${connected ? "bg-[#00FF66] animate-pulse" : "bg-gray-600"}`} />
        <span className="rx-label" data-testid="ws-status">{connected ? "LIVE" : "OFFLINE"}</span>
        <span data-testid="feed-source-badge" title={feed?.error || (liveStocks ? "NSE stock prices from INDstocks" : "All prices simulated")}
          className={`hidden sm:inline text-[9px] font-bold tracking-widest rounded px-1.5 py-0.5 border ${liveStocks ? "text-[#00FF66] border-[#00FF66]/40" : "text-[#FFCC00] border-[#FFCC00]/40"}`}>
          {liveStocks ? "NSE STOCKS · INDSTOCKS" : "SIMULATED"}
        </span>
      </div>
      <div className="flex-1 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_4%,#000_94%,transparent)]">
        <div className="inline-flex rx-marquee">{row("a")}{row("b")}</div>
      </div>
      {global && (
        <div className="hidden md:flex items-center gap-2 px-3 shrink-0 border-l border-white/5 h-full font-data text-xs" data-testid="ticker-impact">
          <span className="text-gray-500">NIFTY IMPACT</span>
          <span className={global.nifty_impact_pts >= 0 ? "text-[#00FF66]" : "text-[#FF3366]"}>{global.nifty_impact_pts >= 0 ? "+" : ""}{fmt(global.nifty_impact_pts)} pts</span>
        </div>
      )}
    </div>
  );
}
